<script lang="ts">
  import type { Snippet } from "svelte";

  // Shared chrome for the public legal pages (Terms / Privacy / Refund).
  // Paddle's merchant review requires each to be a stable, publicly
  // reachable URL, so they always render regardless of billing state —
  // only the footer links to them are gated (see SiteShell).
  let {
    title,
    effective,
    children,
  }: {
    title: string;
    effective: string;
    children: Snippet;
  } = $props();
</script>

<section class="max-w-3xl mx-auto px-6 py-16">
  <h1 class="text-3xl font-bold tracking-tight">{title}</h1>
  <p class="mt-2 text-sm text-slate-500">Last updated: {effective}</p>

  <div
    class="mt-8 space-y-4 text-sm leading-relaxed text-slate-300
      [&_h2]:mt-8 [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-white
      [&_ul]:list-disc [&_ul]:space-y-1 [&_ul]:pl-5
      [&_a]:text-indigo-400 [&_a]:underline [&_a:hover]:text-indigo-300"
  >
    {@render children()}
  </div>
</section>
